// © 2025 Camp Promethean, LLC. All Rights Reserved.

export function AgroChemLogTooltipContent() {
  return (
    <div className="space-y-2.5 text-xs leading-relaxed">
      <p className="text-sm font-medium">Applicator Log</p>
      <p>
        Log spray applications, manage your chemistry library, build tank mixes, and track REI
        (re-entry interval) compliance across rooms and zones.
      </p>
      <div>
        <p className="font-medium">How to use</p>
        <ol className="mt-1 list-decimal space-y-0.5 pl-4">
          <li>Applications → Log application — record room, product, rate, and applicator.</li>
          <li>Applications → History — review past sprays and active REI windows.</li>
          <li>Chemistry library — register products (EPA #, REI) and save reusable tank mixes.</li>
        </ol>
      </div>
      <div>
        <p className="font-medium">Key features</p>
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          <li>REI tracking per room after each application</li>
          <li>Tank mix builder for multi-product recipes</li>
          <li>Hands-free entry for logging in the field</li>
        </ul>
      </div>
      <p className="text-muted-foreground">
        Register chemistries once, then pick them quickly when logging daily spray events.
      </p>
    </div>
  );
}
